// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ContestPosts__list":"ta_a bib_rc bib_qx bib_xr","ContestPosts__more":"ta_b bib_vu bib_b bib_va bib_sv"};